export default __webpack_public_path__ + "static/media/blue-loader.13659d50.svg";